import React from "react";
import { AuthProvider } from "./providers/authProvider";
import { BrowserRouter } from "react-router-dom";
import {RoutesOnecomm} from "./routes/routes";

export const App = () => (
    <AuthProvider>
        <BrowserRouter children={RoutesOnecomm} basename={"/"}/>
    </AuthProvider>
);